import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-40" }
const _hoisted_2 = { class: "stepHeader" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", { class: "line" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "1", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", { class: "line" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "2", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "3", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("payments.payment")), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({ selected: _ctx.step === 1, completed: _ctx.step > 1 })
        }, _hoisted_5, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ selected: _ctx.step === 2, completed: _ctx.step > 2 })
        }, _hoisted_8, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ selected: _ctx.step === 3 })
        }, _hoisted_10, 2)
      ])
    ]),
    _hoisted_11,
    (_ctx.step === 1)
      ? (_openBlock(), _createBlock(_component_Step1, {
          key: 0,
          onSubmit: _ctx.selectPaymentMethod,
          invoice: _ctx.invoice
        }, null, 8, ["onSubmit", "invoice"]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createBlock(_component_Step2, {
          key: 1,
          onSubmit: _ctx.storeCardForm,
          onPrevious: _ctx.toStepOne,
          invoice: _ctx.invoice
        }, null, 8, ["onSubmit", "onPrevious", "invoice"]))
      : _createCommentVNode("", true),
    (_ctx.step === 3)
      ? (_openBlock(), _createBlock(_component_Step3, {
          key: 2,
          onPrevious: _ctx.toStepOne,
          onSubmit: _ctx.payment,
          invoice: _ctx.invoice
        }, null, 8, ["onPrevious", "onSubmit", "invoice"]))
      : _createCommentVNode("", true)
  ]))
}